const firebaseConfig = {
  apiKey: "AIzaSyBQeFsxkPhSL-_qoUosHTM8ceJSSD-yXkQ",
  authDomain: "amadeus-2d849.firebaseapp.com",
  databaseURL: "https://amadeus-2d849.firebaseio.com",
  projectId: "amadeus-2d849",
  storageBucket: "amadeus-2d849.appspot.com",
  messagingSenderId: "69523802945",
  appId: "1:69523802945:web:02ac6a23d8f1f02f42efc0",
  measurementId: "G-P1XD9Q095Z"
};

export default firebaseConfig;